import { gql } from '@apollo/client';

import { AppRequestFragment } from './appRequests.fragment';

export * from './appRequestCreate.mutation.generated';

export const APP_REQUEST_CREATE = gql`
  mutation appRequestCreate($appRequestParams: AppRequestParams!) {
    appRequestCreate(input: { appRequestParams: $appRequestParams }) {
      errors
      success
      appRequest {
        ...AppRequestFragment
      }
    }
  }
  ${AppRequestFragment}
`;
